<p-image
  [src]="url()"
  [alt]="description()"
  [width]="isResponsive() ? '100%' : width().toString()"
  [height]="isResponsive() ? 'auto' : height().toString()"
  [imageStyle]="imageStyle()"
  [loading]="loading()" />
